import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder} from '@aspnet/signalr';
import * as signalR from '@aspnet/signalr';
import { Observable } from 'rxjs';


import { EventsService } from './events.service';
import { AuthenticationService } from './authentication.service';
import { environment } from '../../../environments/environment';

import {
    ICamera
} from '../../shared/models';



declare var $: any;

@Injectable()
export class SignalrService {
    private hubConnection: HubConnection;
     

    constructor(private events: EventsService, private authService: AuthenticationService) {
        console.log(`SignalR hub hubConnectionUrl: [${environment.hubConnectionUrl}]`)    
        this.hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(environment.hubConnectionUrl, {
            //skipNegotiation: true,
            transport: signalR.HttpTransportType.LongPolling
            }) // SignalR hub URL     
      .configureLogging(signalR.LogLevel.Debug)      
      .build();
            
     }

    public startConnection(): Observable<void> {
                return new Observable<void>((observer) => {
        this.hubConnection
            .start()
            .then(() => {
              console.log('Connection established with SignalR hub');
           observer.next();
           observer.complete();
         })
         .catch((error) => {
            if (error !== null && error.length < 1) {
              console.log('SignalrService error is empty');
            }
            else{
            console.log(`Error connecting to SignalR hub: error=[${error.toString()}]`)           
            observer.error(error);
            }
         });

     });
    }

    public OnCloseConnection(): Observable<void> {
        return new Observable<void>((observer) => {
            this.hubConnection.onclose(() => {
            debugger;
            setTimeout(() => {
            debugger;
            this.hubConnection.start().then(() => {
              debugger;
               console.log("connection started");
               observer.next();
               observer.complete();
            }).catch((error) => {
            if (error !== null && error.length < 1) {
              console.log("SignalrService error is empty");
            }
            else{
            console.log(`Error connecting to SignalR hub: error=[${error}]`)           
            observer.error(error);
            }
         });
            }, 5000);
        });        

     });
    }

    

    cameraForMapChanged(): Observable<ICamera> {
        return new Observable<ICamera>((observer) => {
          this.hubConnection.on('CameraForMapChanged', (camera: ICamera) => {
          console.log(`SignalR hub cameraForMapChanged Name=[${camera.name}]`);
           observer.next(camera);
       });
      });
    }

    

    getTableUpdated() {
        console.log('SignalR getTableUpdated');
        return this.events.eventTableUpdated;
    }

    getCameraUpdated() {
        console.log('SignalR getCameraUpdated');
        return this.events.cameraChanged;
    }
}
